export const qsa = document.querySelectorAll.bind(document)
